<!-- eslint-disable no-unused-expressions -->
<template>
  <div id="oacxDiv" class="modal-wrap"></div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { loadOacxPopup } from '../api/loginout'

export default {
  name: 'OacxPopupViews',
  emits: ['update:checkOacx'],
  setup() {
    const loadData = ref('')
    const baseUrl = ref(localStorage.getItem('baseUrl'))
    const certInfo = ref(localStorage.getItem('certInfo'))
    const callbackUrl = ref(localStorage.getItem('callbackUrl'))
    const sid = ref(localStorage.getItem('sid'))

    const scriptLoaded = ref(false)

    // 외부 스크립트를 동적으로 로드하기 위한 함수
    const loadScripts = async (urls) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const url of urls) {
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve, reject) => {
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = url
          script.onload = resolve
          script.onerror = reject
          document.head.appendChild(script)
        })
      }
    }
    const loadCss = (url) =>
      new Promise((resolve, reject) => {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        // link.type = 'text/css';
        link.type = 'text/css'
        link.href = url
        link.onload = () => {
          resolve()
          scriptLoaded.value = true // 스크립트 로드 완료 시 상태 변경
        }
        link.onerror = reject
        document.head.appendChild(link)
      })
    // 로드된 스크립트를 초기화하는 함수
    const clearLocalStorage = () => {
      localStorage.removeItem('baseUrl')
      localStorage.removeItem('callbackUrl')
      localStorage.removeItem('sid')
    }

    onMounted(() => {
      document.addEventListener('DOMContentLoaded', async () => {
        loadData.value = await loadOacxPopup()
        if (loadData.value.code === 'MB32000200') {
          const uxcssUrl = `${baseUrl.value}/sign/esign/oacx-ux.css`
          const scriptUrls = [
            `${baseUrl.value}/sign/esign/oacx-vendor.js`,
            `${baseUrl.value}/sign/esign/oacx-ux.js`,
          ]
          try {
            await loadCss(uxcssUrl)
            await loadScripts(scriptUrls)

            /* json 데이터 */
            const json = {
              contentInfo: {
                signTarget: 'test123',
              },
              userInfo: {
                name: '', // 이름 (ex 홍길동)
                phone1: '', // 휴대폰번호 앞자리 3자리 (ex 010)
                phone2: '', // 휴대폰번호 뒷자리 7,8자리 (ex 12345678)
                telcoTycd: '', // S,K,L
                birthday: '', // 생년월일 (ex 19900101)
              },
              certinfo: certInfo.value, // oacx-ux.js에서 Axios(=ajax)로 API 통신 시 certInfo 값을 header에 포함시켜 API 요청함
              appPush: false,
            }

            // window.addEventListener('load', function () {
            localStorage.removeItem('certInfo')
            localStorage.removeItem('chkPoint')
            window.OACX.LOAD_MODULE(
              `${baseUrl.value}/sign/esign/config/config.auth.json`,
              json,
              async (res) => {
                // eslint-disable-next-line no-param-reassign
                res = JSON.parse(res)
                await fetch(callbackUrl.value, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json;charset=utf-8' },
                  body: JSON.stringify({
                    token: res.token,
                    sid: localStorage.getItem('sid'),
                  }),
                })
                // eslint-disable-next-line no-unused-expressions
                clearLocalStorage
                window.close()
                // clearLocalStorage()
                // // eslint-disable-next-line no-restricted-globals
                // self.opener = self
                // window.close()
              }
            )
            // eslint-disable-next-line func-names
            window.OACX.options.callback.event.close = function () {
              // eslint-disable-next-line no-unused-expressions
              clearLocalStorage
              window.close()
            }
            window.OACX.options.callback.ajax.success.authComplete =
              // eslint-disable-next-line func-names
              function () {
                // console.log('authComplete');
              }
            // });
            window.addEventListener('beforeunload', () => {
              // eslint-disable-next-line no-unused-expressions
              clearLocalStorage
              window.opener.postMessage('popupClosed', '*')
              // console.log(event)
            })
          } catch (err) {
            console.log(err)
          }
        }
      })
    })
    onBeforeUnmount(() => {
      clearLocalStorage()
    })
    return {
      loadData,
      baseUrl,
      certInfo,
      callbackUrl,
      sid,
    }
  },
}
</script>
